/* eslint-disable */
import React from 'react'
import { View } from '../../Components'
import { Colors } from '../../global'

const styles = {
  container: {
    flex: 0,
    flexGrow: 1,
    flexShrink: 0,
    backgroundColor: Colors.white,
    // borderTopLeftRadius: 16,
    // borderTopRightRadius: 16,
    // borderBottomRightRadius: 16,
    // borderBottomLeftRadius: 16,
    shadowOpacity: 0.05,
    shadowRadius: 4,
    shadowColor: Colors.accent,
    shadowOffset: { height: 10, width: 0 },
  },
  circle: {
    aspectRatio: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    backgroundColor: Colors.white,
    borderRadius: 45,
    shadowOpacity: 0.05,
    shadowRadius: 4,
    shadowColor: Colors.grey,
    shadowOffset: { height: 10, width: 0 },
  },
}

const Card = ({ style, children, as = 'container', size }) => {
  const sizeStyle = {}
  if (size) {
    sizeStyle['width'] = size
    sizeStyle['height'] = size
  }
  return (
    <View padding="md" style={{ ...styles[as], ...style, ...sizeStyle }}>
      {children}
    </View>
  )
}

export default Card
